import { State, Action } from './typings'
import {
  selectBillTo,
  loadRelated,
  matchService,
  setSaving,
  unmatchService,
} from './actions'

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'selectBillTo':
      return selectBillTo(state, action.payload)
    case 'loadRelated':
      return loadRelated(state, action.payload)
    case 'matchService':
      return matchService(state, action.payload)
    case 'unmatchService':
      return unmatchService(state, action.payload)
    case 'setSaving':
      return setSaving(state, action.payload)
  }
}
